var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 24.3334,
    cy: 24.3193,
    r: 23.5,
    fill: "white",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3334 33.3193V21.9293C34.3334 20.6073 34.3334 19.9453 33.9894 19.4333C33.6454 18.9213 33.0364 18.6753 31.8194 18.1833L25.8194 15.7633C25.0854 15.4673 24.7194 15.3193 24.3334 15.3193C23.9474 15.3193 23.5814 15.4673 22.8474 15.7633L16.8474 18.1833C15.6304 18.6753 15.0214 18.9213 14.6774 19.4333C14.3334 19.9453 14.3334 20.6073 14.3334 21.9293V33.3193M28.3334 31.3193V33.3193M20.3334 31.3193V33.3193",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8334 26.3193L20.0764 25.3493C20.4394 23.8943 20.6214 23.1663 21.1644 22.7433C21.7064 22.3193 22.4564 22.3193 23.9564 22.3193H24.7104C26.2104 22.3193 26.9604 22.3193 27.5024 22.7433C28.0454 23.1663 28.2274 23.8933 28.5904 25.3493L28.8334 26.3193M29.3334 26.3193H19.3334C19.0682 26.3193 18.8138 26.4247 18.6263 26.6122C18.4387 26.7998 18.3334 27.0541 18.3334 27.3193V30.3193C18.3334 30.5846 18.4387 30.8389 18.6263 31.0264C18.8138 31.214 19.0682 31.3193 19.3334 31.3193H29.3334C29.5986 31.3193 29.8529 31.214 30.0405 31.0264C30.228 30.8389 30.3334 30.5846 30.3334 30.3193V27.3193C30.3334 27.0541 30.228 26.7998 30.0405 26.6122C29.8529 26.4247 29.5986 26.3193 29.3334 26.3193ZM20.8334 28.8093V28.8193V28.8093ZM27.8334 28.8093V28.8193V28.8093Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8334 26.3193L20.0764 25.3493C20.4394 23.8943 20.6214 23.1663 21.1644 22.7433C21.7064 22.3193 22.4564 22.3193 23.9564 22.3193H24.7104C26.2104 22.3193 26.9604 22.3193 27.5024 22.7433C28.0454 23.1663 28.2274 23.8933 28.5904 25.3493L28.8334 26.3193M20.8334 28.8093V28.8193M27.8334 28.8093V28.8193M29.3334 26.3193H19.3334C19.0682 26.3193 18.8138 26.4247 18.6263 26.6122C18.4387 26.7998 18.3334 27.0541 18.3334 27.3193V30.3193C18.3334 30.5846 18.4387 30.8389 18.6263 31.0264C18.8138 31.214 19.0682 31.3193 19.3334 31.3193H29.3334C29.5986 31.3193 29.8529 31.214 30.0405 31.0264C30.228 30.8389 30.3334 30.5846 30.3334 30.3193V27.3193C30.3334 27.0541 30.228 26.7998 30.0405 26.6122C29.8529 26.4247 29.5986 26.3193 29.3334 26.3193Z",
    stroke: "#9264DC",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.590c0875e9e291d6dff97c49d08fe933.svg";
export { ForwardRef as ReactComponent };